import Bugsnag from 'bugsnag-js';
import $ from 'jquery'; // eslint-disable-line no-restricted-imports
Bugsnag.projectRoot = window.location.protocol + '//' + window.location.host + '/projects';
Bugsnag.context = window.location.pathname.replace(/^\/projects/, '');
Bugsnag.beforeNotify = function(payload, metaData) {
    metaData.payload = payload;
    payload.message = payload.message || '';

    return !(
        false ||
        // Snowplow bug in Safari 7+
        payload.message === "TypeError: null is not an object (evaluating 'u.nodeName')" ||
        // Snowplow bug that doesn't affect user experience
        (payload.message.match(/^SecurityError: DOM Exception 18:/) &&
            payload.file.match(/sp-0\.8\.2-1\.js/)) ||
        // http://stackoverflow.com/questions/5913978/cryptic-script-error-reported-in-javascript-in-chrome-and-firefox
        payload.message === 'Script error.' ||
        // Chrome extensions
        // https://developer.chrome.com/extensions/storage.html
        payload.message === "TypeError: Cannot read property 'local' of undefined" ||
        // 3rd party toolbar http://toolbar.conduit.com/
        payload.message.match(/conduitPage/) ||
        payload.message.match(/EBCallBackMessageReceived/) ||
        // 3rd party toolbar http://www.dealply.com/
        payload.message.match(/DealPly/) ||
        // The Tale of an Unfindable JS Error http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
        payload.message.match(/originalCreateNotification/) ||
        payload.message.match(/atomicFindClose/) ||
        payload.message.match(/jid1-ejhbjdxm9zr4tq/) ||
        payload.message.match(/miscellaneous_bindings/) ||
        // IE8
        // http://support.microsoft.com/kb/2688188
        payload.message.match(/Invalid pointer/) ||
        // Firefox
        // Extension erors https://support.mozilla.org/en-US/questions/942331
        payload.message.match(/Error: syntax error/) ||
        // Browser plugin
        payload.message.match(
            /SkypeClick2Call/ ||
                // Firefox websocket dropped
                payload.message.match(/NS_ERROR_UNEXPECTED/)
        )
    );
};

$(document).ready(function() {
    Bugsnag.user = {
        id: $('html').data('user'),
    };
});



// WEBPACK FOOTER //
// ./src/js/page/bugsnag.js